<template>
  <div class="filtros-para-relatorio">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === "" && cpntTipo >= 1 && Object.keys(formulario).length >= 1 && Object.keys(formulario.campos).length >= 1'>
      <table :data-time='time'>
        <tr v-for="(linha, indexL) in formulario.campos" :key="indexL">
          <td v-for="(campo, indexC) in linha" :key="indexL + '--' + indexC" :colspan="campo.colspan">
            <div v-if="campo.tipo === 'filtros'" style="text-align: center;">
              <RF-Button 
                :cpntId='campo.id'
                :cpntStatus='""' 
                :cpntTexto='campo.texto' 
                :cpntDisabled='campo.disabled' 
                :cpntClass='[ "btn", "btn-default" ]' 

                @onClickButton='campo.onClick'
              ></RF-Button>

              <RF-Checkbox-Tabela :data-time='time' style='position: relative; margin-left: 5px; top: 0px;' v-if="campo.hasOwnProperty('onChangeCheckbox')"
                :cpntStatus='""'
                :cpntId='campo.id + "--checkbox"' 
                :cpntNome='""'
                :cpntValue='"NENHUM"'
                :cpntChecked='campo.value'
                :cpntDisabled='campo.onChangeCheckbox === null'
                :cpntExplica='(campo.onChangeCheckbox !== null ? { mensagem: "Marque esta opção caso NÃO deseje buscar por " + campo.nome + " ." } : { titulo: "", mensagem: "Não aplicável" })'

                :cpntOnChange='campo.onChangeCheckbox'
              ></RF-Checkbox-Tabela>

              <RF-Filtros :data-time='time' v-if="campo.mostrar === true"
                :cpntNome="campo.nome"
                :cpntTipo="campo.modelo"
                :cpntFiltrarNenhum="campo.hasOwnProperty('onChangeCheckbox') ? campo.value.indexOf('NENHUM') !== -1 : null"
                :cpntMostrarFiltrarNenhum="campo.hasOwnProperty('onChangeCheckbox') && campo.onChangeCheckbox !== null"
                :cpntCheckbox="campo.value"
                :cpntFiltros="campo.filtros"
                :cpntFiltroFecharDialog='campo.onClick'
              ></RF-Filtros>
            </div>

            <RF-Componente v-else-if="campo.tipo !== 'select2'"
              :data-time='time'
              :cpntTamanho='campo.tamanho'
              :cpntModelo='campo.tipo'
              :cpntStatus='campo.status'
              :cpntId='campo.id'
              :cpntClassDivField='campo.classDivField'
              :cpntNome='campo.nome'
              :cpntValue='campo.value'
              :cpntValueRef='campo.valueRef'
              :cpntOptions='campo.options'
              :cpntKeyValue='campo.keyValue'
              :cpntKeyMostra='campo.keyMostra'
              :cpntAutoComplete='campo.autocomplete'
              :cpntDisabled='campo.disabled'
              :cpntMostrar='campo.mostrar'
              :cpntMensagem='campo.mensagem'
              :cpntSelecioneNome='campo.selecioneNome'
              :cpntSelecioneValue='campo.selecioneValue'
              :cpntMensagemTipo='campo.mensagemTipo'
              :cpntAdicinarOption='campo.adicinarOption'
              :cpntMultiple='campo.multiple'
              :cpntAllRegistro='campo.allRegistro'
              :cpntExplica='campo.explica'
              :cpntTabIndex='campo.tabIndex'
              :cpntOptionInicialNome='campo.optionInicialNome'
              :cpntOptionInicialValue='campo.optionInicialValue'

              :cpntOnChange='campo.onChange'
              :cpntOnBlur='campo.onBlur'
              :ref='campo.tipo'
            ></RF-Componente>
            <div v-else class="rf-cpnt-group-select2">
              <div>
                <RF-Componente
                  :data-time='time'
                  :cpntTamanho='campo.tamanho'
                  :cpntModelo='campo.tipo'
                  :cpntStatus='campo.status'
                  :cpntId='campo.id'
                  :cpntClassDivField='campo.classDivField'
                  :cpntNome='campo.nome'
                  :cpntValue='campo.value'
                  :cpntValueRef='campo.valueRef'
                  :cpntOptions='campo.options'
                  :cpntKeyValue='campo.keyValue'
                  :cpntKeyMostra='campo.keyMostra'
                  :cpntAutoComplete='campo.autocomplete'
                  :cpntDisabled='campo.disabled'
                  :cpntMostrar='campo.mostrar'
                  :cpntMensagem='campo.mensagem'
                  :cpntSelecioneNome='campo.selecioneNome'
                  :cpntSelecioneValue='campo.selecioneValue'
                  :cpntMensagemTipo='campo.mensagemTipo'
                  :cpntAdicinarOption='campo.adicinarOption'
                  :cpntMultiple='campo.multiple'
                  :cpntAllRegistro='campo.allRegistro'
                  :cpntExplica='campo.explica'
                  :cpntTabIndex='campo.tabIndex'
                  :cpntOptionInicialNome='campo.optionInicialNome'
                  :cpntOptionInicialValue='campo.optionInicialValue'

                  :cpntOnChange='campo.onChange'
                  :cpntOnBlur='campo.onBlur'
                  :ref='campo.tipo'
                ></RF-Componente>
              </div>
            </div>
          </td>
        </tr>
      </table>

      <div :colspan="Object.keys(buttonBuscar).length >= 1">
        <RF-Button
          :data-time='time'
          :cpntId='buttonBuscar.id'
          :cpntStatus='buttonBuscar.status' 
          :cpntTexto='buttonBuscar.texto' 
          :cpntClass='buttonBuscar.class' 

          @onClickButton='buttonBuscar.onClick'
        ></RF-Button>
      </div>
    </template>
  </div>
</template>

<style scoped>
.filtros-para-relatorio > table {
  width: 100%;

  border-collapse: separate;
  border-spacing: 2px;
}
  .filtros-para-relatorio > table > tr > td > .rf-cpnt-group-select2,
  .filtros-para-relatorio > table > tr > td > .rf-cpnt-group-filtro-data {
    margin-top: 15px;
  }
  .filtros-para-relatorio > table > tr > td {
    padding: 2px;
    padding: 8px 0px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
    .filtros-para-relatorio > table > tr:first-child > td:first-child > div {
      margin-top: 0px;
      margin-bottom: 5px;
    }

    .filtros-para-relatorio > table > tr > td > div {
      height: 100%;
      text-align: center;
      vertical-align: middle;
    }

.filtros-para-relatorio > div {
  text-align: center;
  padding: 10px 0px;
}
</style>

<style>
  .filtros-para-relatorio > table > tr > td > div,
  .filtros-para-relatorio > table > tr > td > div > div {
    width: 100% !important;
    min-width: 336px !important;
    max-width: initial !important;
  }
  .filtros-para-relatorio > table > tr > td > div > div {
    max-width: 390px !important;
    margin: 0px auto;
  }
  .filtros-para-relatorio > table > tr > td > div > .rf-select2-chosen-aberto {
    padding: 20px 10px 0px 10px;
  }
  .filtros-para-relatorio > table > tr > td > div > div > div,
  .filtros-para-relatorio > table > tr > td > div > div > div > div > div {
    margin-bottom: 0px !important;
  }
  .filtros-para-relatorio > table > tr > td > div > .intervalo-valores-aberto {
    margin-top: 5px;
    padding: 0px 10px 0px 10px;
  }
</style>

<script>
  export default {
    props: {
      cpntNome: {
        type: String,
        required: true
      },
      cpntTipo: {
        type: Number,
        required: true
      },
      cpntPesquisar: {
        required: true
      }
    },
    components: {
      'RF-Filtros': () => import('@/components/rf-geral/filtros/Filtros.vue'),
      'RF-Checkbox-Tabela': () => import('@/components/rf-geral/checkbox/RF-Checkbox-Tabela.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        formulario: {},
        qtdeFiltro: 0,
        contagem: [],
        buttonBuscar: {},
        options: {}
      }
    },
    mounted: function () {
      this.filtroParaRelatorioIniciar()
    },
    methods: {
      filtroParaRelatorioIniciar: function () {
        // SETA O STATUS GERAL
        this.filtroParaRelatorioStatusGeral('carregando')

        // INICIA O VETOR DE CONTAGEM NOVAMENTE
        this.contagem = []

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        this.formulario = {
          status: 'carregando',
          id: 'vendas-relatorios-filtro',
          field: {}
        }

        switch (this.cpntNome + '_' + this.cpntTipo) {
          case 'venda_0':
            // SETA A QUANTIDADE DE FILTROS
            this.qtdeFiltro = 0

            // SETA O STATUS GERAL
            this.filtroParaRelatorioStatusGeral('')
            break

          case 'venda_1':
            // SETA A QUANTIDADE DE FILTROS
            this.qtdeFiltro = 8

            // CHAMA FUNÇÃO PARA CRIAR FILTRO STATUS VENDA
            this.filtroParaRelatorioBuscarStatusVenda()

            // CHAMA FUNÇÃO PARA CRIAR FILTRO DATA VENDA
            this.filtroParaRelatorioBuscarPeriodo('periodo', 'Período', '2')

            // // CHAMA A FUNÇÃO PARA BUSCAR OS VEICULOS
            // this.filtroParaRelatorioBuscarTipos()

            // CHAMA A FUNÇÃO PARA BUSCAR CATEGORIA
            this.filtroParaRelatorioBuscarProduto('produtos', 'Produto', this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 15 ], 'and', null, null, null, null, false) === true)

            // CHAMA A FUNÇÃO PARA BUSCAR CATEGORIA
            this.filtroParaRelatorioBuscarServico('servicos', 'Serviço', this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 15 ], 'and', null, null, null, null, false) === true)

            // CHAMA A FUNÇÃO PARA BUSCAR OS CONTATOS
            this.filtroParaRelatorioBuscarContatos()

            // CHAMA A FUNÇÃO PARA BUSCAR OS VEICULOS
            this.filtroParaRelatorioBuscarVeiculos()

            // CHAMA A FUNÇÃO PARA CRIAR O FILTRO PARA NOTA DE ENTRADA
            this.filtroParaRelatorioBuscarNotasEntrada()

            // CHAMA A FUNÇÃO PARA BUSCAR OS COMISSIONADOS
            this.filtroParaRelatorioBuscarComissionado('comissionado', 'Vendedor')
            break

          case 'venda_2':
            // SETA A QUANTIDADE DE FILTROS
            this.qtdeFiltro = 8

            // CHAMA FUNÇÃO PARA CRIAR FILTRO STATUS VENDA
            this.filtroParaRelatorioBuscarStatusVenda()

            // CHAMA FUNÇÃO PARA CRIAR FILTRO DATA VENDA
            this.filtroParaRelatorioBuscarPeriodo('periodo', 'Período', '2')

            // CHAMA A FUNÇÃO PARA BUSCAR OS VEICULOS
            this.filtroParaRelatorioBuscarTipos()

            // CHAMA A FUNÇÃO PARA BUSCAR CATEGORIA
            this.filtroParaRelatorioBuscarProduto('produtos', 'Produto', this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 15 ], 'and', null, null, null, null, false) === true)

            // CHAMA A FUNÇÃO PARA BUSCAR CATEGORIA
            this.filtroParaRelatorioBuscarServico('servicos', 'Serviço', this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 15 ], 'and', null, null, null, null, false) === true)

            // CHAMA A FUNÇÃO PARA BUSCAR OS CONTATOS
            this.filtroParaRelatorioBuscarContatos()

            // CHAMA A FUNÇÃO PARA BUSCAR OS VEICULOS
            this.filtroParaRelatorioBuscarVeiculos()

            // CHAMA A FUNÇÃO PARA CRIAR O FILTRO PARA NOTA DE ENTRADA
            this.filtroParaRelatorioBuscarNotasEntrada()

            // CHAMA A FUNÇÃO PARA BUSCAR OS COMISSIONADOS
            this.filtroParaRelatorioBuscarComissionado('comissionado', 'Vendedor')
            break

          // case 'venda_4':
          //   // SETA A QUANTIDADE DE FILTROS
          //   this.qtdeFiltro = 6

          //   // CHAMA FUNÇÃO PARA CRIAR FILTRO STATUS VENDA
          //   this.filtroParaRelatorioBuscarStatusVenda()

          //   // CHAMA FUNÇÃO PARA CRIAR FILTRO DATA VENDA
          //   this.filtroParaRelatorioBuscarPeriodo('periodo', 'Período', '')

          //   // // CHAMA A FUNÇÃO PARA BUSCAR OS VEICULOS
          //   // this.filtroParaRelatorioBuscarTipos()

          //   // CHAMA A FUNÇÃO PARA BUSCAR CATEGORIA
          //   this.filtroParaRelatorioBuscarProduto('produtos', 'Produto', this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 15 ], 'and', null, null, null, null, false) === true)

          //   // CHAMA A FUNÇÃO PARA BUSCAR CATEGORIA
          //   this.filtroParaRelatorioBuscarServico('servicos', 'Serviço', this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 15 ], 'and', null, null, null, null, false) === true)

          //   // CHAMA A FUNÇÃO PARA BUSCAR OS CONTATOS
          //   this.filtroParaRelatorioBuscarContatos()

          //   // CHAMA A FUNÇÃO PARA BUSCAR OS VEICULOS
          //   this.filtroParaRelatorioBuscarVeiculos()

          //   // CHAMA A FUNÇÃO PARA BUSCAR OS COMISSIONADOS
          //   this.filtroParaRelatorioBuscarComissionado('comissionado', 'Vendedor')
          //   break

          case 'produto_1':
            // SETA A QUANTIDADE DE FILTROS
            this.qtdeFiltro = 3

            // CHAMA A FUNÇÃO PARA BUSCAR CATEGORIA
            this.filtroParaRelatorioBuscarProduto('produtos', 'Produto', false)

            // CHAMA A FUNÇÃO PARA BUSCAR MARCA
            this.filtroParaRelatorioTipoDeBusca()

            // CHAMA A FUNÇÃO PARA BUSCAR MARCA
            this.filtroParaRelatorioIntervaloValor()
            break

          case 'produto_2':
            // SETA A QUANTIDADE DE FILTROS
            this.qtdeFiltro = 5

            // CHAMA A FUNÇÃO PARA BUSCAR CATEGORIA
            this.filtroParaRelatorioBuscarProduto('produtos', 'Produto', false)

            // CHAMA A FUNÇÃO PARA BUSCAR OS CLIENTES EM CONTATO
            this.filtroParaRelatorioBuscarContatos('con_venda', 'Clientes', false)

            // CHAMA A FUNÇÃO PARA BUSCAR OS VEICULOS
            this.filtroParaRelatorioBuscarVeiculos('veiculo', 'Veículo', false)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PET
            this.filtroParaRelatorioBuscarPet('pet', 'Pet', false)

            // CHAMA FUNÇÃO PARA CRIAR FILTRO DATA VENDA
            this.filtroParaRelatorioBuscarPeriodo('periodo', 'Período', '2')
            break

          default:
            this.$store.state.msgWarn('WEB [500]: Filtro com nome (' + this.cpntNome + ') do tipo (' + this.cpntTipo + ') não encontrado. ', 'danger')
            break
        }
        
        // CHAMA A FUNÇÃO PARA CRIAR O BOTÃO PESQUISAR DO RELATORIO
        this.filtroParaRelatorioCamposAdicionais()
      },
      filtroParaRelatorioLimpar: function () {
        this.cpntPesquisar('LIMPAR', this.filtroParaRelatorioSetarStatusButton)
      },
      filtroParaRelatorioBuscarTipos: function () {
        // SETA O CAMPO TIPO BUSCA
        this.formulario.field.tipoBusca = {
          tamanho: 52,
          tipo: 'select2',
          status: '',
          nome: 'Tipo de Relatório:',
          id: this.formulario.id + '-tipoBusca',
          options: [],
          value: '2',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          optionInicialNome: '',
          onChange: this.filtroParaRelatorioOnChangeValue
        }
        
        switch (this.cpntTipo) {
          case 2:
            this.formulario.field.tipoBusca.options = [
              { id: '1', nome: 'Ticket médio diário' },
              { id: '4', nome: 'Ticket médio mensal' },
              { id: '2', nome: 'Valor total diário' },
              { id: '5', nome: 'Valor total mensal' },
              { id: '3', nome: 'Quantidade diária' },
              { id: '6', nome: 'Quantidade mensal' }
            ]
            break
        }

        // SETA A INFORMAÇÕES DE CONTAGEM
        this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarTipos')
      },
      filtroParaRelatorioBuscarProduto: function (chave = 'produtos', nome = 'Produto', nenhum = true) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === true) {
          var self = this
  
          // SETA O CAMPO CATEGORIA
          self.formulario.field[chave] = {
            tamanho: 74,
            tipo: 'filtros',
            modelo: 'produtos',
            nome: nome,
            mostrar: false,
            value: [ ],
            filtrosInicial: { categoria: [ 't' ], marca: [ 't' ] },
            onChangeCheckbox: nenhum === true ? this.filtroParaRelatorioOnChangeValueCheckbox : null,
            onClick: function (atualizar = '', value = [], extra = {}) {
              switch (atualizar) {
                case true:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = false

                  // SETA O VALOR ATUALIZADO PARA ABRIR O CAMPO
                  self.formulario.field[chave].value = value

                  // SETA OS FILTROS UTILIZADOS
                  self.formulario.field[chave].filtros = Object.keys(extra).length === 0 ? self.formulario.field[chave].filtrosInicial : extra

                  // CHAMA A FUNÇÃO PARA LIMPAR O RELATORIO
                  self.filtroParaRelatorioLimpar()
                  break

                case false:
                default:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = !self.formulario.field[chave].mostrar
                  break
              }

              // CHAMA A FUNÇÃO PARA MONTAR O NOME DO BOTÃO
              self.filtroParaRelatorioMontarBotao('produtos')

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }

          // CHAMA A FUNÇÃO PARA SETAR O NOME DO BOTÃO
          self.filtroParaRelatorioMontarBotao('produtos', true)

          // SETA A INFORMAÇÕES DE CONTAGEM
          self.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarProduto')
        } else {
          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarProduto')
        }
      },
      filtroParaRelatorioBuscarServico: function (chave = 'servicos', nome = 'Serviço', nenhum = true) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, null, null, false) === true) {
          var self = this
  
          // SETA O CAMPO CATEGORIA
          self.formulario.field[chave] = {
            tamanho: 74,
            tipo: 'filtros',
            modelo: 'servicos',
            nome: nome,
            mostrar: false,
            value: [],
            filtrosInicial: { categoria: [ 't' ] },
            onChangeCheckbox: nenhum === true ? this.filtroParaRelatorioOnChangeValueCheckbox : null,
            onClick: function (atualizar = '', value = [], extra = {}) {
              switch (atualizar) {
                case true:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = false

                  // SETA O VALOR ATUALIZADO PARA ABRIR O CAMPO
                  self.formulario.field[chave].value = value

                  // SETA OS FILTROS UTILIZADOS
                  self.formulario.field[chave].filtros = Object.keys(extra).length === 0 ? self.formulario.field[chave].filtrosInicial : extra

                  // CHAMA A FUNÇÃO PARA LIMPAR O RELATORIO
                  self.filtroParaRelatorioLimpar()
                  break

                case false:
                default:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = !self.formulario.field[chave].mostrar
                  break
              }

              // CHAMA A FUNÇÃO PARA MONTAR O NOME DO BOTÃO
              self.filtroParaRelatorioMontarBotao(chave)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }

          // CHAMA A FUNÇÃO PARA SETAR O NOME DO BOTÃO
          self.filtroParaRelatorioMontarBotao(chave, true)

          // SETA A INFORMAÇÕES DE CONTAGEM
          self.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarServico')
        } else {
          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarServico')
        }
      },
      filtroParaRelatorioBuscarContatos: function (chave = 'contato', nome = 'Contato', nenhum = false) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, null, null, null, null, false) === true) {
          var self = this

          // SETA O CAMPO CATEGORIA
          self.formulario.field[chave] = {
            tamanho: 74,
            tipo: 'filtros',
            modelo: 'contatos',
            nome: nome,
            mostrar: false,
            value: [],
            filtrosInicial: { tp_contato: [ 't' ] },
            onChangeCheckbox: nenhum === true ? this.filtroParaRelatorioOnChangeValueCheckbox : null,
            onClick: function (atualizar = '', value = [], extra = {}) {
              switch (atualizar) {
                case true:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = false

                  // SETA O VALOR ATUALIZADO PARA ABRIR O CAMPO
                  self.formulario.field[chave].value = value

                  // SETA OS FILTROS UTILIZADOS
                  self.formulario.field[chave].filtros = Object.keys(extra).length === 0 ? self.formulario.field[chave].filtrosInicial : extra

                  // CHAMA A FUNÇÃO PARA LIMPAR O RELATORIO
                  self.filtroParaRelatorioLimpar()
                  break

                case false:
                default:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = !self.formulario.field[chave].mostrar
                  break
              }

              // CHAMA A FUNÇÃO PARA MONTAR O NOME DO BOTÃO
              self.filtroParaRelatorioMontarBotao(chave)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }

          // CHAMA A FUNÇÃO PARA SETAR O NOME DO BOTÃO
          self.filtroParaRelatorioMontarBotao(chave, true)

          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarContatos')
        } else {
          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscar' + chave)
        }
      },
      filtroParaRelatorioBuscarVeiculos: function (chave = 'veiculo', nome = 'Veículo', nenhum = true) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true) {
          var self = this

          // SETA O CAMPO CATEGORIA
          self.formulario.field[chave] = {
            tamanho: 74,
            tipo: 'filtros',
            modelo: 'veiculos',
            nome: nome,
            mostrar: false,
            value: [],
            filtrosInicial: { contato: [ 't' ], modelo: [ 't' ], marca: [ 't' ] },
            onChangeCheckbox: nenhum === true ? this.filtroParaRelatorioOnChangeValueCheckbox : null,
            onClick: function (atualizar = '', value = [], extra = {}) {
              switch (atualizar) {
                case true:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = false

                  // SETA O VALOR ATUALIZADO PARA ABRIR O CAMPO
                  self.formulario.field[chave].value = value

                  // SETA OS FILTROS UTILIZADOS
                  self.formulario.field[chave].filtros = Object.keys(extra).length === 0 ? self.formulario.field[chave].filtrosInicial : extra

                  // CHAMA A FUNÇÃO PARA LIMPAR O RELATORIO
                  self.filtroParaRelatorioLimpar()
                  break

                case false:
                default:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = !self.formulario.field[chave].mostrar
                  break
              }

              // CHAMA A FUNÇÃO PARA MONTAR O NOME DO BOTÃO
              self.filtroParaRelatorioMontarBotao(chave)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }

          // CHAMA A FUNÇÃO PARA SETAR O NOME DO BOTÃO
          self.filtroParaRelatorioMontarBotao(chave, true)

          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarVeiculos')
        } else {
          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarVeiculos')
        }
      },
      filtroParaRelatorioBuscarNotasEntrada: function (chave = 'tpNF', nome = 'Tipo de NF-e', valor = '100') {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20 ], null, null, null, null, null, false) === true) {
          // SETA O CAMPO STATUS VENDA
          this.formulario.field[chave] = {
            tamanho: 74,
            tipo: 'select2',
            status: '',
            nome: nome,
            id: this.formulario.id + '-' + chave,
            value: valor,
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            optionInicialNome: '',
            optionInicialValue: '',
            options: [
              { id: '100', nome: 'Todos' },
              { id: '0', nome: 'NF-e de entrada' },
              { id: '1', nome: 'NF-e de saída' },
              { id: '101', nome: 'NF-e de entrada e saída' },
              { id: '102', nome: 'Sem emissão de NF-e' }
            ],
            onChange: this.filtroParaRelatorioOnChangeValue
          }

          // // CHAMA A FUNÇÃO PARA SETAR O NOME DO BOTÃO
          // self.filtroParaRelatorioMontarBotao(chave, true)

          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarNotasEntrada')
        } else {
          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarNotasEntrada')
        }
      },
      filtroParaRelatorioBuscarPet: function (chave = 'pet', nome = 'Pet', nenhum = true) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, null, null, null, null, false) === true) {
          var self = this

          // SETA O CAMPO CATEGORIA
          self.formulario.field[chave] = {
            tamanho: 74,
            tipo: 'filtros',
            modelo: 'pet',
            nome: nome,
            mostrar: false,
            value: [],
            filtrosInicial: { contato: [ 't' ], modelo: [ 't' ], marca: [ 't' ] },
            onChangeCheckbox: nenhum === true ? this.filtroParaRelatorioOnChangeValueCheckbox : null,
            onClick: function (atualizar = '', value = [], extra = {}) {
              switch (atualizar) {
                case true:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = false

                  // SETA O VALOR ATUALIZADO PARA ABRIR O CAMPO
                  self.formulario.field[chave].value = value

                  // SETA OS FILTROS UTILIZADOS
                  self.formulario.field[chave].filtros = Object.keys(extra).length === 0 ? self.formulario.field[chave].filtrosInicial : extra

                  // CHAMA A FUNÇÃO PARA LIMPAR O RELATORIO
                  self.filtroParaRelatorioLimpar()
                  break

                case false:
                default:
                  // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
                  self.formulario.field[chave].mostrar = !self.formulario.field[chave].mostrar
                  break
              }

              // CHAMA A FUNÇÃO PARA MONTAR O NOME DO BOTÃO
              self.filtroParaRelatorioMontarBotao(chave)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }

          // CHAMA A FUNÇÃO PARA SETAR O NOME DO BOTÃO
          self.filtroParaRelatorioMontarBotao(chave, true)

          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarPet')
        } else {
          // SETA A INFORMAÇÕES DE CONTAGEM
          this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarPet')
        }
      },
      filtroParaRelatorioTipoDeBusca: function () {
        // SETA O CAMPO CONTATO
        this.formulario.field.tipoBusca = {
          tamanho: 52,
          tipo: 'select2',
          status: '',
          nome: 'Tipo de busca',
          id: this.formulario.id + '-tipoBusca',
          options: [],
          value: 't',
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          optionInicialNome: 'Todos',
          optionInicialValue: 't',
          onChange: this.filtroParaRelatorioOnChangeValue
        }
        
        switch (this.cpntTipo) {
          case 1:
            this.formulario.field.tipoBusca.options = [
              { id: '0', nome: 'Estoque menor ou igual a zero' },
              { id: '1', nome: 'Estoque maior ou igual a zero' },
              { id: '2', nome: 'Estoque maior que zero' },
              { id: '3', nome: 'Calcular estoque desativado' },
              { id: '4', nome: 'Calcular estoque ativado' },
              { id: '5', nome: 'Quantidade em estoque abaixo da quantidade mínima' }
            ]
            break
        }

        // SETA A INFORMAÇÕES DE CONTAGEM
        this.filtroParaRelatorioFinalizar('filtroParaRelatorioTipoDeBusca')
      },
      filtroParaRelatorioIntervaloValor: function () {
        // SETA O CAMPO CONTATO
        this.formulario.field.intervalo = {
          tamanho: 52,
          tipo: 'intervalo-valores',
          status: '',
          nome: 'Intervalo de valores (de venda)',
          id: this.formulario.id + '-intervalo',
          value: true,
          value1: '',
          value2: '',
          onChange: this.filtroParaRelatorioOnChangeValue
        }

        // SETA A INFORMAÇÕES DE CONTAGEM
        this.filtroParaRelatorioFinalizar('filtroParaRelatorioIntervaloValor')
      },
      filtroParaRelatorioBuscarPeriodo: function (chave = 'periodo', nome = 'Período', valor = '') {
        // SETA O CAMPO STATUS VENDA
        this.formulario.field[chave] = {
          tamanho: 74,
          tipo: 'filtro-data',
          status: '',
          nome: nome,
          id: this.formulario.id + '-' + chave,
          dataIni: null,
          dataFim: null,
          value: valor,
          onChange: this.filtroParaRelatorioOnChangeValue
        }

        // SETA A INFORMAÇÕES DE CONTAGEM
        this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscar' + chave)
      },
      filtroParaRelatorioBuscarComissionado: function (chave = 'comissionado', nome = 'Vendedor', valor = [ 't' ]) {
        var self = this

        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === true) {
          // SETA O CAMPO STATUS VENDA
          this.formulario.field[chave] = {
            tamanho: 74,
            tipo: 'select2-chosen',
            nome: nome,
            id: this.formulario.id + '-' + chave,
            multiple: true,
            allRegistro: 'Todos',
            value: valor,
            keyValue: 'id_con',
            keyMostra: [ 'id_con', ' - ', 'id_con_nome' ],
            options: [],
            onChangeCheckbox: null,
            onChange: this.filtroParaRelatorioOnChangeValue
          }
  
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id_con: { j: { nome: null } } }, where: { f: 'status', o: '=', v: '1' } }
  
          // REALIZA A BUSCA DOS DADOS NA API
          self.$store.state.comunicaAPI('/comissao/config/comissionado/get', 'POST', queryGet, function (apiSuccess) {
            // SETA OS DADOS RECEBIDOS
            self.formulario.field[chave].options = apiSuccess.data
  
            // SETA OS DADOS RECEBIDOS
            self.formulario.field[chave].value = valor
  
            // SETA A INFORMAÇÕES DE CONTAGEM
            self.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscar' + chave)
          }, self.filtroParaRelatorioStatusGeral)
        } else {
          // SETA A INFORMAÇÕES DE CONTAGEM
          self.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscar' + chave)
        }
      },
      filtroParaRelatorioBuscarStatusVenda: function () {
        // SETA O CAMPO STATUS VENDA
        this.formulario.field.status_ven = {
          tamanho: 74,
          tipo: 'select2-chosen',
          nome: 'Status',
          id: this.formulario.id + '-status_ven',
          multiple: true,
          allRegistro: 'Todos',
          value: [ '2' ],
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          options: [
            { id: '1', nome: 'Orçamento' },
            { id: '2', nome: 'Venda'  }
          ],
          onChange: this.filtroParaRelatorioOnChangeValue
        }

        // SETA A INFORMAÇÕES DE CONTAGEM
        this.filtroParaRelatorioFinalizar('filtroParaRelatorioBuscarStatusVenda')
      },
      filtroParaRelatorioCamposAdicionais: function () {
        var self = this

        self.buttonBuscar = {
          id: self.formulario.id + '-buscar',
          status: '',
          tipo: 'texto',
          texto: 'Pesquisar',
          class: [ 'btn', 'btn-primary' ],
          onClick: function () {
            // INICIA A VARIAVEL QUE RECEBE O FILTRO
            var filtros = {}

            // COLOCA OS VALORES SELECIONADOS NA VARIAVEL
            for (var lin in self.formulario.campos) {
              for (var key in self.formulario.campos[lin]) {
                switch (key) {
                  case 'periodo':
                    filtros[key] = { value: self.formulario.campos[lin][key].value, dataIni: self.formulario.campos[lin][key].dataIni, dataFim: self.formulario.campos[lin][key].dataFim }
                    break

                  case 'intervalo':
                    filtros[key] = { valorIni: self.formulario.campos[lin][key].value1, valorFim: self.formulario.campos[lin][key].value2 }
                    break

                  default:
                    filtros[key] = self.formulario.campos[lin][key].value
                    break
                }
              }
            }

            // SETA O STATUS NO BOTÃO
            self.filtroParaRelatorioSetarStatusButton('carregando')
            
            // CHAMA A FUNÇÃO PARA PESQUISAR
            self.cpntPesquisar(filtros, self.filtroParaRelatorioSetarStatusButton)
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // SETA A INFORMAÇÕES DE CONTAGEM
        self.filtroParaRelatorioFinalizar('filtroParaRelatorioCamposAdicionais')
      },
      filtroParaRelatorioFinalizar: function (id) {
        var self = this

        // SALVA A CONTAGEM DE FINALIZAÇÕES
        self.contagem.push(id)

        // REMOVER VALORES DUPLICADOS
        self.contagem = self.contagem.filter((v, i, a) => a.indexOf(v) === i)

        if (self.contagem.length === (self.qtdeFiltro + 1)) {
          // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
          self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
            var linha = 0
            var coluna = 0
            var qtdeColuna = 1
            self.formulario.campos = {}

            var qtdeCampos = Object.keys(fields).length

            for (var key in fields) {
              // INICIA O VALOR DO CAMPO
              if (!self.formulario.campos.hasOwnProperty(linha)) {
                self.formulario.campos[linha] = {}
              }

              // SETA O COLSPAN DA COLUNA
              fields[key].colspan = 1

              switch (self.cpntNome + '_' + self.cpntTipo) {
                case 'venda_1': {
                  switch (qtdeCampos) {
                    case 4:
                    case 5: {
                      qtdeColuna = 2
                      switch (linha + '_' + coluna) {
                        case '0_0':
                        case '0_1':
                        case '1_0':
                        case '1_1': {
                          fields[key].colspan = 1
                          break
                        }

                        case '2_0': {
                          fields[key].colspan = 2
                          qtdeColuna = 1
                          break
                        }
                      }
                      break
                    }

                    case 6: {
                      fields[key].colspan = 1
                      qtdeColuna = 2
                      break
                    }

                    case 7: {
                      fields[key].colspan = 1
                      qtdeColuna = 2

                      switch (linha + '_' + coluna) {
                        case '3_0': {
                          fields[key].colspan = 2
                          break
                        }
                      }
                      break
                    }
                    case 8: {
                      fields[key].colspan = 1
                      qtdeColuna = 2
                      break
                    }
                  }
                  break
                }

                default: {
                  switch (qtdeCampos) {
                    case 1:
                    case 2:
                    case 3: {
                      qtdeColuna = qtdeCampos
                      break
                    }
    
                    case 4: {
                      switch (linha + '_' + coluna) {
                        case '1_0': {
                          fields[key].colspan = 3
                          break
                        }
                      }
                      qtdeColuna = 3
                      break
                    }
    
                    case 5:
                    case 7: {
                      qtdeColuna = 3
                      switch (linha + '_' + coluna) {
                        case '0_1': {
                          fields[key].colspan = 2
                          qtdeColuna = 3
                          break
                        }
    
                        case '1_0':
                        case '1_1':
                        case '2_0':
                        case '2_1': {
                          fields[key].colspan = 2
                          qtdeColuna = 2
                          break
                        }
                      }
                      break
                    }
    
                    case 6: {
                      qtdeColuna = 3
                      switch (linha + '_' + coluna) {
                        case '0_1': {
                          fields[key].colspan = 2
                          qtdeColuna = 3
                          break
                        }
    
                        case '1_0':
                        case '1_1': {
                          fields[key].colspan = 2
                          qtdeColuna = 2
                          break
                        }
    
                        case '2_0': {
                          fields[key].colspan = 4
                          qtdeColuna = 1
                          break
                        }
                      }
                      break
                    }
    
                    case 8: {
                      qtdeColuna = 3
                      switch (linha + '_' + coluna) {                    
                        case '0_1':
                        case '1_1':
                        case '2_0':
                        case '2_1': {
                          fields[key].colspan = 2
                          break
                        }
    
                        default: {
                          fields[key].colspan = 1
                          qtdeColuna = 3
                          break
                        }
                      }
                      break
                    }
    
                    case 10: {
                      qtdeColuna = 2
                      switch (linha + '_' + coluna) {
                        case '0_0':
                        case '0_1':
                        case '0_2':
                        case '1_0':
                        case '1_1':
                        case '1_2': {
                          fields[key].colspan = 2
                          qtdeColuna = 3
                          break
                        }
    
                        case '2_0':
                        case '2_1':
                        case '3_0':
                        case '3_1': {
                          fields[key].colspan = 3
                          break
                        }
                      }
                      break
                    }
    
                    default: {
                      qtdeColuna = 3
                      break
                    }
                  }
                }
              }

              // INICIA A COLUNA
              self.formulario.campos[linha][key] = {}

              // ADICIONA O CAMPO NA LINHA
              self.formulario.campos[linha][key] = fields[key]

              // SETA O ID ATUALIZADO DO CAMPO
              self.formulario.campos[linha][key].id = self.formulario.id + '--' + linha + '--' + key
 
              // SOMA OS DADOS DA LINHA
              coluna++

              if (coluna >= qtdeColuna) {
                // REINICIA A CONTAGEM DA COLUNA
                coluna = 0

                // SOMA A QUANTIDADE DE LINHA PARA PROXIMA
                linha++
              }
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // SETA O STATUS DA TELA
            self.filtroParaRelatorioStatusGeral('')
          })
        }
      },
      filtroParaRelatorioSetarStatusButton: function (status) {
        // SETA O STATUS RECEBIDO
        this.buttonBuscar.status = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      filtroParaRelatorioMontarBotao: function (chave, iniciando = false) {
        // LIMPA O NOME DO PRODUTO INSERIDO
        this.formulario.field[chave].texto = ''

        // PEGA OS VALORES MARCADOS
        var valor = this.formulario.field[chave].value

        if (valor.indexOf('NENHUM') !== -1) {
          // SETA O TEXTO DO CAMPO
          this.formulario.field[chave].texto = 'Não mostrar ' + this.formulario.field[chave].nome + ' no relatório.'

          // SETA O BOTÃO COMO DESATIVADO
          this.formulario.field[chave].disabled = true
        } else if (this.formulario.field[chave].value !== null && this.formulario.field[chave].value.length >= 1) {
          // SETA O TEXTO DO CAMPO
          this.formulario.field[chave].texto = this.formulario.field[chave].value.length + " - " + this.formulario.field[chave].nome + "(s) selecionado(s)"

          // SETA O BOTÃO COMO DESATIVADO
          this.formulario.field[chave].disabled = false
        } else {
          // SETA O TEXTO DO CAMPO
          this.formulario.field[chave].texto = this.formulario.field[chave].nome + " [Todos]"

          // SETA O BOTÃO COMO DESATIVADO
          this.formulario.field[chave].disabled = false
        }

        // SETA OS FILTROS UTILIZADOS
        if (iniciando === true) {
          this.formulario.field[chave].filtros = this.formulario.field[chave].filtrosInicial
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      filtroParaRelatorioOnChangeValueCheckbox: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        // SETA SE DEVE OU NÃO MOSTRAR O CAMPO
        this.formulario.field[index[2]].mostrar = false

        switch (value) {
          case true:
            // SETA O VALOR ATUALIZADO PARA ABRIR O CAMPO
            this.formulario.field[index[2]].value = [ 'NENHUM' ]
            break;
        
          default:
            // SETA O VALOR ATUALIZADO PARA ABRIR O CAMPO
            this.formulario.field[index[2]].value = []
            break
        }

        // CHAMA A FUNÇÃO PARA MONTAR O NOME DO BOTÃO
        this.filtroParaRelatorioMontarBotao(index[2])

        // LIMPA OS FILTROS SELECIONADOS
        this.formulario.field[index[2]].filtros = this.formulario.field[index[2]].filtrosInicial

        // CHAMA A FUNÇÃO PARA LIMPAR O RELATORIO
        this.filtroParaRelatorioLimpar()

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      filtroParaRelatorioOnChangeValue: function (value, id, extra = null) {
        var value1 = ''
        var value2 = ''
        if (extra !== null) {
          value1 = value
          value2 = id
          id = extra
        }

        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')

        switch (index[2]) {
          case 'bt-mostrar':
            // SETA O NOVO VALOR PARA O CAMPO
            this.formulario.field.intervalo.todos = !this.formulario.field.intervalo.todos
            break

          case 'periodo':
            this.formulario.field[index[2]].value = index[3]
            this.formulario.field[index[2]].dataIni = value1
            this.formulario.field[index[2]].dataFim = value2

            // REMOVE A MENSAGEM DE ERRO
            this.formulario.field[index[2]].mensagem = ''
            this.formulario.field[index[2]].mensagemTipo = ''
            break

          case 'intervalo':
            this.formulario.field[index[2]].value1 = value1
            this.formulario.field[index[2]].value2 = value2

            // REMOVE A MENSAGEM DE ERRO
            this.formulario.field[index[2]].mensagem = ''
            this.formulario.field[index[2]].mensagemTipo = ''
            break

          default:
            // SETA O VALOR RECEBIDO
            this.formulario.field[index[2]].value = value
    
            // REMOVE A MENSAGEM DE ERRO
            this.formulario.field[index[2]].mensagem = ''
            this.formulario.field[index[2]].mensagemTipo = ''
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      filtroParaRelatorioStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    watch: {
      cpntTipo: function () {
        this.filtroParaRelatorioIniciar()
      }
    }
  }
</script>
